import React from 'react';
import { NavLink } from 'react-router-dom';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

import useForgotPassword from './useForgotPassword';
import AuthLayout from './AuthLayout';
import AuthForm from './AuthForm';
import ForgotPasswordInfo from './ForgotPasswordInfo';
import { Path } from '../../routes';
import MediaIcon from '@assets/img/auth-media.svg';
import MailboxIcon from '@assets/img/auth-mailbox.svg';
import MailIcon from '@assets/img/input-mail.svg';

function ForgotPasswordPage(props) {
  const {
    email,
    showInfo,
    showError,
    onSubmit,
    onSendAgain,
    onBlur,
  } = useForgotPassword();
  const { t } = useTranslation();

  return (
    <AuthLayout
      className="forgot-password-page"
      title={!showInfo ? t('password-recovery') : t('check-your-email')}
      icon={
        !showInfo ? (
          <MediaIcon width={215} height={160} />
        ) : (
          <MailboxIcon width={160} height={160} />
        )
      }
    >
      {!showInfo ? (
        [
          <AuthForm
            onSubmit={onSubmit}
            name="forgot-password"
            submitLabel={t('restore-password')}
          >
            <Form.Item
              className="auth-form__item"
              name="email"
              validateStatus={showError && 'error'}
              help={showError && t('enter-correct-email')}
              rules={[{ required: true, message: t('fill-your-email') }]}
            >
              <Input
                type="email"
                onBlur={onBlur}
                prefix={<MailIcon width={18} height={18} />}
                placeholder={t('write-your-email')}
              />
            </Form.Item>
          </AuthForm>,
          <div className="auth-form__login-link">
            <NavLink to={Path.LOGIN}>{t('come-in')}</NavLink>{' '}
            {t('if-you-remember')}
          </div>,
        ]
      ) : (
        <ForgotPasswordInfo onClick={onSendAgain} email={email} />
      )}
    </AuthLayout>
  );
}

export default ForgotPasswordPage;
